import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import useStyles from '../styles';

export interface HeaderIconProps {
  className?: string;
}

export const HeaderIcon: FC<PropsWithChildren<HeaderIconProps>> = ({ children, className }) => {
  const classes = useStyles();
  return <div className={classNames(classes.headerIcon, className)}>{children}</div>;
};

export default HeaderIcon;
